import { ToastService } from '@captiveaire/toast';
import * as _ from 'lodash';
import { IDictionary } from '../dictionary/IDictionary';
import { BaseDeviceActivation } from './base-device-activation';
import { Component, DoCheck, Input } from '@angular/core';
import { CellularDeviceActivationService } from './cellular-device-activation.service';

@Component({
    selector: 'cl-cellular-device-activation',
    templateUrl: './cellular-device-activation.component.html'
})
export class CellularDeviceActivationComponent extends BaseDeviceActivation implements DoCheck {
    public static $name: string = 'clCellularDeviceActivation';
    
    @Input() isCellularDeviceValid: boolean;
    @Input() isActive: boolean;
    @Input() jobNumber: number;
    @Input() locationId: number;
    @Input() moduleId: number;
    @Input() allowedMobileIdTypes: CASLink.Device.Ui.ViewModel.Modules.MobileIdTypeViewModel[];
    @Input() vendor: CASLink.Device.Ui.ViewModel.Modules.CellularVendorViewModel;
    @Input() carrier: CASLink.Device.Ui.ViewModel.Modules.CellularCarrierViewModel;
    @Input() canRequestActivation: boolean;
    @Input() deviceIdentifierMap: IDictionary<string>;

    isForcedDisabled: boolean;
    
    private wasCellularDeviceValid: boolean;
    private previousDeviceIdentifierMap: IDictionary<string>;

    constructor(
        private cellularDeviceActivationService: CellularDeviceActivationService,
        private toastService: ToastService
    ) {
        super();
    }

    public ngDoCheck() {
        this.doCheckDeviceIdentifierMap();
    }

    public sendActivationRequest() {
        this.prepareRequest();

        return this.submitRequest();
    }

    private doCheckDeviceIdentifierMap() {
        let mapChanged: boolean = !_.isEqual(this.previousDeviceIdentifierMap, this.deviceIdentifierMap);
        let validityChanged: boolean = this.wasCellularDeviceValid !== this.isCellularDeviceValid;

        if (mapChanged) {
            this.previousDeviceIdentifierMap = _.cloneDeep(this.deviceIdentifierMap);
        }

        if (validityChanged) {
            this.wasCellularDeviceValid = this.isCellularDeviceValid;
        }

        let shouldValidate = mapChanged || validityChanged;

        if (shouldValidate) {
            this.validateDeviceIdentifierMap();
        }
    }

    private submitRequest() {
        return this.cellularDeviceActivationService.sendActivationRequest(this.cellularDeviceActivationViewModel).then(response => {
            if (response.success) {
                this.toastService.create({ message: 'Activation Requested!' });
                this.canRequestActivation = false;
            } else {
                this.toastService.create({ message: response.validation.map(error => error.message).join(', ') });
            }
        });
    }

    /**
     * This is an async validator that will be called when any device identifier field is edited.
     * If they were all valid and passed the server-side check, then the button
     * to request activation should appear and be enabled, even if it was not available to start
     */
    private validateDeviceIdentifierMap() {
        if (this.isCellularDeviceValid) {
            this.isForcedDisabled = true; // disable while looking

            let filteredIdentifiers = this.filterIrrelevantDeviceIdentifiers(this.deviceIdentifierMap);

            this.cellularDeviceActivationService
                .validateIdentifiers(filteredIdentifiers, this.vendor.id, this.moduleId)
                .then((result: boolean) => {
                    this.canRequestActivation = result;

                    this.isForcedDisabled = false;
                });
        }
    }
}
